import { useMemo, useState } from 'react';

import { getPointsByTypes } from '../helpers/getPointsByTypes';
import { getPointTypes } from '../helpers/getPointTypes';
import { PickupPoint, PointType } from '../types';

/**
 * Хук для управления точками самовывоза
 */
export function usePointsController(points: PickupPoint[]) {
  const pointTypes = useMemo(() => getPointTypes(points), [points]);

  const pointsByTypes = useMemo(
    () => getPointsByTypes(points, pointTypes),
    [points, pointTypes]
  );

  const [selectedPointType, setSelectedPointType] = useState<PointType | null>(
    null
  );

  /**
   * Видимые точки самовывоза после фильтрации
   */
  const visiblePoints = useMemo(() => {
    return selectedPointType === null
      ? pointsByTypes
      : pointsByTypes.filter((points) => points.type === selectedPointType);
  }, [pointsByTypes, selectedPointType]);

  /**
   * Обработчик изменения типа точки самовывоза
   */
  const handlePointTypeChange = (type: PointType | null) => {
    setSelectedPointType(type);
  };

  return {
    pointTypes,
    pointsByTypes,
    visiblePoints,
    selectedPointType,
    setSelectedPointType,
    handlePointTypeChange
  };
}
